module.exports = __webpack_public_path__ + "img/lc-front.141bf5a8.svg";